
import { defineComponent, ref, watch } from "vue";
import {
  Container,
  Section,
  Heading1,
  NarrowContainer,
} from "@/components/layout";
import { useI18n } from "vue-i18n";
import { useChangeLocale } from "@/hooks";

export default defineComponent({
  name: "Hero",
  components: { Container, Section, Heading1, NarrowContainer },
  setup() {
    const { t } = useI18n();
    const { currentLocale } = useChangeLocale();
    const greetingsSrc = ref(t("hero.greetings"));
    const fullNameSrc = ref(t("hero.fullName"));
    const greetingsDest = ref("");
    const fullNameDest = ref("");
    const loadingGreetings = ref(true);
    const loadingFullName = ref(false);

    const greetingsTyping = () => {
      if (greetingsDest.value.length < greetingsSrc.value.length) {
        greetingsDest.value += greetingsSrc.value.charAt(
          greetingsDest.value.length,
        );
        setTimeout(greetingsTyping, 100);
      } else {
        setTimeout(() => {
          loadingGreetings.value = false;
          loadingFullName.value = true;
          fullNameTyping();
        }, 250);
      }
    };

    const fullNameTyping = () => {
      if (fullNameDest.value.length < fullNameSrc.value.length) {
        fullNameDest.value += fullNameSrc.value.charAt(
          fullNameDest.value.length,
        );
        setTimeout(fullNameTyping, 100);
      } else {
        setTimeout(() => {
          loadingFullName.value = false;
        }, 250);
      }
    };

    setTimeout(greetingsTyping, 200);

    watch(
      currentLocale,
      () => {
        greetingsSrc.value = t("hero.greetings");
        fullNameSrc.value = t("hero.fullName");
        greetingsDest.value = "";
        fullNameDest.value = "";
        loadingGreetings.value = true;
        loadingFullName.value = false;
        greetingsTyping();
      },
      { deep: true },
    );

    return { greetingsDest, fullNameDest, loadingGreetings, loadingFullName };
  },
});
